/**
 * Decodes a JWT's `exp` claim client-side, purely to schedule a proactive silent-refresh timer.
 * This does NOT verify the signature and grants no trust to the value — a JWT's payload is base64
 * encoded, not encrypted, so reading it client-side to know roughly when to ask the server for a
 * new token is standard practice and safe (the server independently validates the signature on
 * every request regardless of what the client believes the expiry is).
 *
 * Returns the expiry in epoch milliseconds, or null if the token is malformed.
 */
export function decodeJwtExpiryMs(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = JSON.parse(atob(padded));

    return typeof json.exp === 'number' ? json.exp * 1000 : null;
  } catch {
    return null;
  }
}
